import React from 'react';

import { Text } from '../core/Text';
import styles from './EmailTypoSuggestion.module.css';

// Подсказка об опечатке в домене email. Рендерится внутри .loginWrapper
// из того же модуля стилей — позиционируется в зазоре между полями формы
// и не влияет на её высоту. Контейнер присутствует всегда: role="status"
// озвучивает появление подсказки, а поле ввода не пересоздаётся.
export default function EmailTypoSuggestion({ suggestion, onApply }) {
  return (
    <span className={styles.suggestion} role="status">
      {suggestion && (
        <span className={styles.suggestion__body}>
          <span className={styles.suggestion__label}>
            <Text>dialog.signup.hint__email_typo</Text>
          </span>
          <button
            type="button"
            className={styles.suggestion__value}
            onClick={onApply}
            title={suggestion.email}
          >
            <span className={styles.suggestion__local}>{suggestion.local}</span>
            <span className={styles.suggestion__domain}>@{suggestion.domain}</span>
          </button>
          <Text>dialog.signup.hint__email_typo_end</Text>
        </span>
      )}
    </span>
  );
}
